import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Sign from "@/pages/Sign";
import Portal from "@/pages/Portal";

function App() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const [view, setView] = useState("landing"); // landing | admin

  if (path.startsWith("/sign/")) {
    const token = decodeURIComponent(path.slice("/sign/".length));
    return (
      <div className="App">
        <Sign token={token} />
        <Toaster position="top-right" />
      </div>
    );
  }

  if (path.startsWith("/portal")) {
    return (
      <div className="App">
        <Portal />
        <Toaster position="top-right" />
      </div>
    );
  }

  return (
    <div className="App">
      {view === "landing" && (
        <Landing onEnterDeck={() => { window.location.href = "/portal"; }} onAdmin={() => setView("admin")} />
      )}
      {view === "admin" && <Admin onBack={() => setView("landing")} />}
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
